"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var GooglePlus32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M11.173 6.5c2.384 0 4.483.827 6.148 2.354a.5.5 0 01.006.732l-2.353 2.222a.5.5 0 01-.686 0c-.763-.719-1.802-1.175-3.115-1.175-2.688 0-4.877 2.183-4.877 4.867s2.189 4.867 4.877 4.867c2.286 0 3.781-1.208 4.282-2.667h-4.282a.5.5 0 01-.5-.5v-2.914a.5.5 0 01.5-.5h8.188a.5.5 0 01.493.412c.101.573.146.978.146 1.496 0 5.181-3.592 8.806-8.827 8.806C6.105 24.5 2 20.477 2 15.5s4.105-9 9.173-9zm0 1C6.653 7.5 3 11.08 3 15.5s3.653 8 8.173 8c4.681 0 7.827-3.175 7.827-7.806 0-.32-.02-.591-.064-.908h-7.263V16.7h4.42a.5.5 0 01.494.578c-.343 2.164-2.308 4.09-5.414 4.09-3.24 0-5.877-2.631-5.877-5.868 0-3.237 2.637-5.867 5.877-5.867 1.39 0 2.545.433 3.442 1.138l1.622-1.531c-1.41-1.134-3.124-1.74-5.064-1.74zm15.327 4a.5.5 0 01.5.5v2h2a.5.5 0 01.5.5V17a.5.5 0 01-.5.5h-2v2a.5.5 0 01-.5.5H24a.5.5 0 01-.5-.5v-2h-2a.5.5 0 01-.5-.5v-2.5a.5.5 0 01.5-.5h2v-2a.5.5 0 01.5-.5h2.5zm-.5 1h-1.5v2a.5.5 0 01-.5.5h-2v1.5h2a.5.5 0 01.5.5v2H26v-2a.5.5 0 01.5-.5h2V15h-2a.5.5 0 01-.5-.5v-2z", className: "google-plus-32_svg__path-1" }))); };
var StyledGooglePlus32 = styled_components_1.default(GooglePlus32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledGooglePlus32;
var templateObject_1;
//# sourceMappingURL=GooglePlus32.js.map